import { ref } from 'vue'

const userNewsModalRequestId = ref(0)

export function useUserNewsModal() {
    const requestOpenUserNewsModal = () => {
        userNewsModalRequestId.value += 1
    }

    return {
        userNewsModalRequestId,
        requestOpenUserNewsModal,
    }
}